import * as env from '../lib/mapper';

const flowIdMapping = env.createFrigadeIdMapping({
  // 'flow-name': 'flow-id',
});

export default flowIdMapping;
